"use strict";



// -------------------------------------- la nav active loul -----------------------------

const navElements = document.querySelectorAll('.navigation__el');

navElements.forEach(function(navEl) {
    navEl.addEventListener('click', function() {

        const navActive = document.querySelector('.navigation__el--active');

        if (navActive) {
            navActive.classList.remove('navigation__el--active');
        }
        this.classList.add('navigation__el--active');
    });
});



// -------------------------------------- le burger menu -----------------------------

const body = document.querySelector("body");
const navigationToggle = document.querySelector(".navigation__toggle");
const navigation = document.querySelector(".navigation");
const navigationLinks = document.querySelectorAll(".navigation__el");


if(navigationToggle){
    navigationToggle.addEventListener("click", navigationOpen); 

    for(let navigationLink of navigationLinks){ 
        navigationLink.addEventListener("click", navigationOpen);
    }
}

function navigationOpen(){ 
    navigation.classList.toggle("navigation--open");
}



// -------------------------------------- le slider loul -----------------------------

const btnPrev = document.querySelector(".slider__btn--prev");
const btnNext = document.querySelector(".slider__btn--next");

btnPrev.addEventListener("click", prevSlide);
btnNext.addEventListener("click", nextSlide);

function nextSlide() {
    const elShow = document.querySelector(".slider__el--show");
    const elNext = elShow.nextElementSibling;

    elShow.classList.remove("slider__el--show");
    if(elNext){
        elNext.classList.add("slider__el--show");
    }else{
        const elFirst = elShow.parentElement.firstElementChild;
        elFirst.classList.add("slider__el--show");
    }
}

function prevSlide() {
    const elShow = document.querySelector(".slider__el--show");
    const elPrev = elShow.previousElementSibling;

    elShow.classList.remove("slider__el--show");
    if(elPrev){
        elPrev.classList.add("slider__el--show");
    }else{
        const elLast = elShow.parentElement.lastElementChild;
        elLast.classList.add("slider__el--show");
    }
}

document.addEventListener("keydown", function(event){
    if(event.code == "ArrowLeft"){
        prevSlide();
    }else if(event.code == "ArrowRight"){
        nextSlide()
    }

});



